import {
  BuildingLibraryIcon,
  BuildingOfficeIcon,
  LocationMarkerIcon,
  MapIcon,
} from "@heroicons/react/24/solid";
// import District from "./District";
// import Territory from "./Territory";
// import Region from "./Region";
// import Area from "./Area";
import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
// import { Business } from "@material-ui/icons";

export const OfficeHierarchyTabs = [
  // {
  //   index: 0,
  //   to: ROUTE_PATHS.Utilities_OfficeHierarchy_District_Index,
  //   path: "/utilities/OfficeHierarchyConfiguration/District/Index",
  //   icon: <BuildingLibraryIcon className="h-4 w-4 float-left mr-2 " />,
  //   title: "District",
  //   component: District,
  //   permission:
  //     PERMISSIONS.permission_utilities_officehierarchyconfiguration_district_view,
  // },
  // {
  //   index: 1,
  //   to: ROUTE_PATHS.Utilities_OfficeHierarchy_Region_Index,
  //   path: "/utilities/OfficeHierarchyConfiguration/Region/Index",
  //   icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2 " />,
  //   title: "Region",
  //   component: Region,
  //   permission:
  //     PERMISSIONS.permission_utilities_officehierarchyconfiguration_region_view,
  // },
  // {
  //   index: 2,
  //   to: ROUTE_PATHS.Utilities_OfficeHierarchy_Area_Index,
  //   path: "/utilities/OfficeHierarchyConfiguration/Area/Index",
  //   icon: <LocationMarkerIcon className="h-4 w-4 float-left mr-2 " />,
  //   title: "Area",
  //   component: Area,
  //   permission:
  //     PERMISSIONS.permission_utilities_officehierarchyconfiguration_area_view,
  // },
  // {
  //   index: 3,
  //   to: ROUTE_PATHS.Utilities_OfficeHierarchy_Territory_Index,
  //   path: "/utilities/OfficeHierarchyConfiguration/Territory/Index",
  //   icon: <MapIcon className="h-4  w-4 float-left mr-2 " />,
  //   title: "Territory",
  //   component: Territory,
  //   permission:
  //     PERMISSIONS.permission_utilities_officehierarchyconfiguration_territory_view,
  // },
];
